import { Stack, Typography } from "@mui/material";
import ModelSelector from "components/model/ModelSelector";
import ActionButton from "components/react-lib/generic-ui/ActionButton";
import ReduxModal from "components/react-lib/generic-ui/modals/ReduxModal";
import Logo from "components/svg/Logo";
import { useAuth } from "context/react-lib/firebase-auth/AuthProvider";
import { addDoc, collection } from "firebase/firestore";
import { db } from "firebaseApp";
import { COLLECTIONS } from "firebaseCollections";
import { fonts } from "fonts";
import { MODALS } from "modals";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { modalsActions } from "store/react-lib/generic-ui/modals";
import { popupActions } from "store/react-lib/generic-ui/popup";

export default function WelcomeModal() {

  const dispatch = useDispatch();
  const auth = useAuth();

  const [searchParams] = useSearchParams();
  const [model, setModel] = useState(searchParams.get("model") || "gpt-5");
  const [creating, setCreating] = useState(false);

  const navigate = useNavigate();

  const handleCreate = async (model) => {
    try {
      setCreating(true);
      await addDoc(collection(db, COLLECTIONS.bots), {
        uid: auth.currentUser.uid,
        name: "Default",
        model: model,
        avatar: "Jaster",
        systemPrompt: "You're a helpful assistant.",
        contextSize: 3,
        createdAt: new Date().getTime(),
        stream: false,
      });
      // await addDoc(collection(db, COLLECTIONS.bots), {
      //   uid: auth.currentUser.uid,
      //   name: "GPT Image",
      //   model: "gpt-image-1",
      //   avatar: "Toby",
      //   systemPrompt: "",
      //   contextSize: 0,
      //   createdAt: new Date().getTime(),
      // });
      dispatch(modalsActions.closeModal(MODALS.onboardingModal));
      navigate("/");
    } catch(error) {
      console.log(error);
      dispatch(popupActions.showError("An error occured while creating your bot."));
    } finally {
      setCreating(false);
    }
  }

  return (
    <ReduxModal
      name={MODALS.onboardingModal}
      fullWidth
      maxWidth="sm"
      title="Welcome to Cheap-GPT"
      closeCallback={() => handleCreate("gpt-4o")}
    >
      <Stack spacing={2}>
        <Typography fontFamily={fonts.anton} textAlign="center">
          Let's create your first bot !
        </Typography>
        <Logo
          style={{
            width: "100px",
            alignSelf: "center",
          }}
        />

        <Typography fontFamily={fonts.anton} textAlign="center">
          What model would you like to try first ?
        </Typography>
        <ModelSelector model={model} setModel={setModel} />
        <ActionButton
          variant="contained"
          onClick={() => handleCreate(model)}
          processing={creating}
        >
          Create
        </ActionButton>
      </Stack>
    </ReduxModal>
  );
}
